<template>
	<div>
		<van-nav-bar title="商品分类">
		  <van-icon name="search"  />
		  <img  @click="goNotice()" src="../../assets/img/icon/notice.png" alt="" slot="right" >
		</van-nav-bar>
		<van-tree-select height="100%"  :items="leftItems"  :main-active-index.sync="active" @click-nav="onClickNav" >
			<template slot="content" >
				<div class="kind">
					<div class="kindBox" v-for="(item,i) in smallKind" :key="i">
						<h5 class="kindTitle">{{item.name}}</h5>
						<div class="kindList" >
							<div class="kindListBox"  @click='goDetail(obj.category_id)' v-for="(obj,index) in item.children" :key="index" > 
								<div class="kindImg" >
									<img :src="obj.image" alt>
								</div>
								<!-- <van-image width="130" height="130" :src="obj.image" /> -->
								<p>{{obj.name}}</p>
							</div>
						</div>
					</div>
				</div>
			</template>
		</van-tree-select>
    <fontNav></fontNav>
	</div>
</template>

<script>
	import listOfItems from '../../components/listOfItems.vue';
	import verticalItemList from '../../components/verticalItemList.vue';
	import fontNav from "../../components/fontNav.vue";
	export default {
		name: 'goodsKind',
		data() {
			return {
				active: 0,
				kindCount:"",
				showContent:0,
				kindData:[],
				secondTitle:[],
				secondContent:[],
				smallKind:[],
				leftItems: []
			}
		},
		components: {
			fontNav
		},
		mounted(){
			this.categoriesData()
		},
		methods: {
          goDetail(category){
			  console.log(category);
			   this.$router.push({
				   path : './goodsList',
				   query :{
						category_id : category
				   }
			   })
		  },
		  
		//   getImgUrl(imgstr){
		// 	  let imgstrs =String(imgstr);
		// 	  console.log(imgstrs)
		// 	  return imgstrs.replace(/http/, "https");
		//   },
		  goNotice(){
			  this.$router.push('./noticeList') 
		  },
		  categoriesData(){
			  let objLeft = {}
			  this.getRequest( 'goods/categories/0/children' ).then(res => {
				  this.kindCount=res.data.data.length;
				  this.kindData=res.data.data;
				  console.log(res)
			    res.data.data.map((item) => {
					item.text=item.name; 
					this.leftItems.push({text:item.text});
				})
				this.onFirstNav(0)
			  })
			  
		  },
		  onFirstNav(val){
			 this.active=val;
			 this.smallKind = this.kindData[val].children;
		  },
		  onClickNav(val){
			 this.active=val;
			 this.smallKind = this.kindData[val].children;
		  }
		  
		},
		  
	}
</script>
<style scoped lang='less'>
	.van-nav-bar{
		background-image: linear-gradient(to right, #FF5145, #E52F23, #CD0F02);
		position: fixed;
		top: 0;
		width: 100%;
	  .van-nav-bar__title{
		  color: #fff;
		  font-size: 36px;
		  font-weight: 500;
		}
	 .van-nav-bar__right{
		 top: 30px;
		 img{
			 width: 42px;
			 height: 40px;
		 }
	}
	}
	.van-tree-select {
		position: absolute;
		padding: 100px 0;
		/deep/ .van-tree-select__nav {
			width: 180px;
			flex: none;
			/deep/ .van-tree-select__nav-item {
				// height: 90px;
				.van-sidebar-item__text {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}
			}
      
			/deep/ .van-sidebar-item--select {
				position: relative;
				border-color: transparent;
				/deep/ &:before{
					content:"" ;
					position: absolute;
					left: 0;
					top: 50%;
					height: 30px;
					margin-top: -25px;
					width: 6px;
					background-color:#FF4444;
					border-radius: 4px;
					z-index: 99;
				}
				/deep/ .van-sidebar-item__text {
					font-weight: bold;
				}


			}
		}
		/deep/ .van-tree-select__nav::-webkit-scrollbar {display:none}
		/deep/ .van-tree-select__content::-webkit-scrollbar{display:none}
	}

	.kind {
		padding: 20px;
		width: 100%;

		.kindBox {
			box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
			padding: 20px 20px 0 20px;
            margin-bottom: 20px;
			.kindTitle {
				font-size: 24px;
				color: #333;
				text-align: left;
				margin: 0;
				margin-bottom: 15px;
			}


			.kindList {
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;

				.kindListBox {
					margin-bottom: 40px;
					/* margin-left: 40px; */
					float: left;
					text-align: center;
					width: 30%;
					margin-left: 5%;
					.kindImg{
						width: 130px;
						height: 130px;
						margin: 0 auto;
						img {
							width: 100%;
							height: 100%;	
						}
					}
					p {
						font-size: 22px;
						text-align: center;
						color: #333;
					}
				}
				.kindListBox:nth-child(3n+1) {
					margin-left: 0;
				}
			}
		}
	}
</style>
